import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { portalApi } from '@/lib/api/portal.js';
import { formatCurrency } from '@/lib/format.js';

export function PortalProfilePage() {
  const meQuery = useQuery({ queryKey: ['portal', 'me'], queryFn: portalApi.me });
  const me = meQuery.data;

  return (
    <div className="space-y-5">
      <h1 className="text-2xl font-bold">My Profile</h1>
      <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <dl className="space-y-3 text-sm">
          <div>
            <dt className="text-slate-500">Name</dt>
            <dd className="font-semibold">
              {[me?.firstName, me?.lastName].filter(Boolean).join(' ')}
            </dd>
          </div>
          <div>
            <dt className="text-slate-500">Email</dt>
            <dd className="font-semibold">{me?.email ?? '—'}</dd>
          </div>
          <div>
            <dt className="text-slate-500">Phone</dt>
            <dd className="font-semibold">{me?.phone ?? '—'}</dd>
          </div>
          <div>
            <dt className="text-slate-500">Loyalty</dt>
            <dd className="font-semibold">{me?.loyaltyPointsBalance ?? 0} pts</dd>
          </div>
          <div>
            <dt className="text-slate-500">Store Credit</dt>
            <dd className="font-semibold">{formatCurrency(me?.storeCreditBalance ?? 0)}</dd>
          </div>
        </dl>
        <Link
          to="/portal/profile/change-password"
          className="mt-5 inline-block rounded-xl border border-slate-300 px-4 py-2 text-sm font-semibold"
        >
          Change Password
        </Link>
      </div>
    </div>
  );
}
